import React from "react";
import About from "./about/About";
import Home from "./home/Home";
import css from "./main.module.css";
import Resume from "./resume/Resume";
import Services from "./services/Services";
import Portfolio from "./portfolio/Portfolio";
import Contact from "./contact/Contact";
import Footer from "./footer/Footer";

import { sideHeaderElements } from "../../data/sideHeader";

const Main = () => {
  const sectionIds = sideHeaderElements[1].list;

  return (
    <main className={css.main}>
      <section id={sectionIds[0].link}>
        <Home />
      </section>

      <section id={sectionIds[1].link}>
        <About />
      </section>

      <section id={sectionIds[2].link}>
        <Services />
      </section>

      <section id={sectionIds[3].link}>
        <Resume />
      </section>

      <section id={sectionIds[4].link}>
        <Portfolio />
      </section>

      <section id={sectionIds[5].link}>
        <Contact />
      </section>

      <Footer />

    </main>
  );
};

export default Main;
